import React from 'react';
import { useIntl } from 'react-intl';

import { EsignatureCCRecipient } from '~/features/ticket/types/esignature';
import { TicketUserItem } from '~/features/ticket/user-item/TicketUserItem';

interface Props {
  recipient: EsignatureCCRecipient;
}

export const TicketCCRecipient = ({ recipient }: Props) => {
  const intl = useIntl();

  return (
    <TicketUserItem
      userId={null}
      externalUser={{ name: recipient.name, email: recipient.email }}
      chip={{
        text: intl.formatMessage({
          id: 'TicketRecipients.cc',
          defaultMessage: 'CC',
          description:
            'Label for if a recipient is added as a CC on a signing package',
        }),
        status: 'info',
      }}
      actions={{
        reassign: false,
        assign: false,
      }}
    />
  );
};
